{
  "auditLogs": {
    "title": "Auditnapló",
    "description": "Összes adatmutáció megtekintése a bérlői entitásokban",
    "timestamp": "Időbélyeg",
    "actor": "Szereplő",
    "action": "Művelet",
    "entityType": "Entitás típus",
    "entityId": "Entitás ID",
    "summary": "Összefoglaló",
    "scope": "Hatókör",
    "superadminScope": "Superadmin",
    "filterByThisActor": "Szűrés erre a szereplőre",
    "filterByThisEntity": "Szűrés erre az entitás típusra",
    "filterByThisEntityId": "Szűrés erre az entitás ID-ra",
    "fieldChanges": "Mezőváltozások",
    "batchInfo": "Kötegelt információ",
    "snapshot": "Dokumentum pillanatkép",
    "empty": "Nem található auditnapló bejegyzés",
    "showing": "{{from}}-{{to}} / {{total}} megjelenítése",
    "previous": "Előző",
    "next": "Következő",
    "systemActor": "Rendszer",
    "ip": "IP",
    "endpoint": "Végpont",
    "sessionId": "Munkamenet-azonosító",
    "actionCreate": "Létrehozás",
    "actionUpdate": "Frissítés",
    "actionSoftDelete": "Soft törlés",
    "actionDestroy": "Végleges törlés",
    "actionBulkSoftDelete": "Tömeges soft törlés",
    "actionBulkDestroy": "Tömeges végleges törlés",
    "actionBulkWrite": "Tömeges írás",
    "field": "Mező",
    "from": "Régi érték",
    "to": "Új érték",
    "batchFilter": "Szűrő",
    "batchUpdate": "Frissítés",
    "batchMatched": "Egyező",
    "batchModified": "Módosított",
    "noDetails": "Nincsenek részletek",
    "fieldsChanged": "{{count}} mező módosítva",
    "matchedModified": "{{matched}} egyező, {{modified}} módosított",
    "snapshotCaptured": "Pillanatkép rögzítve"
  },
  "tenantAdmin": {
    "title": "Bérlők",
    "description": "A rendszer összes bérlőjének kezelése",
    "createTenant": "Bérlő létrehozása",
    "editTenant": "Bérlő szerkesztése",
    "updateTenant": "Bérlő frissítése",
    "createDescription": "Új bérlő hozzáadása a rendszerhez",
    "cloneTenant": "Bérlő duplikálása",
    "cloneDescription": "{{name}} független másolatának létrehozása, beleértve az összes adatát.",
    "cloneNameDefault": "{{name}} másolata",
    "cloneWarningTitle": "A felhasználók is átmásolódnak",
    "cloneWarning": "A másolat minden felhasználót a meglévő bejelentkezési adataival másol át. Minden felhasználó ugyanazzal az e-mail-címmel és jelszóval jelentkezhet be mindkét bérlőbe.",
    "cloneStarted": "A duplikálás a háttérben fut. Az új bérlő aktívvá válik, amint befejeződik.",
    "cloneRunningBadge": "létrehozás alatt…",
    "cloneRunningTooltip": "A duplikálás a háttérben fut: {{phase}}",
    "clonePhaseCopying": "adatok másolása",
    "clonePhaseProvisioning": "hozzáférések létrehozása",
    "clonePhaseImporting": "demó hozzáférések importálása",
    "cloneInterruptedBadge": "Duplikálás megszakadt",
    "cloneFailedBadge": "Duplikálás sikertelen",
    "cloneImportFailedBadge": "Hiányzó demó belépések",
    "cloneImportFailed": "A bérlő duplikálása befejeződött és használatra kész, de a demó belépések létrehozása nem sikerült. Az import újrafuttatásáig senki sem tud bejelentkezni.",
    "cloneCompletedBadge": "Megmaradt értesítés",
    "cloneCompleted": "A duplikálás befejeződött, a bérlő használatra kész. Csak ez az értesítés nem törlődött automatikusan — elrejtése biztonságos.",
    "cloneInterruptedAlertTitle": "A(z) {{name}} duplikálása megszakadt",
    "cloneInterruptedAlert": "A duplikálás megszakadt, és nem fejeződött be. Semmi nem került törlésre: a hiányos bérlő ({{slug}}) továbbra is létezik, és inaktív. Az „Elvetés és törlés” eltávolítja az adatbázisával és a tagságokkal együtt, a „Figyelmen kívül hagyás” megtartja, és csak ezt az értesítést rejti el.",
    "cloneFailedAlertTitle": "A(z) {{name}} duplikálása sikertelen",
    "cloneFailedAlert": "A duplikálás sikertelen volt, és visszaállításra került. Ami a hiányos bérlőből ({{slug}}) megmaradt, inaktív. Az „Elvetés és törlés” eltávolítja a maradékot az adatbázisával és tagságaival együtt, a „Figyelmen kívül hagyás” megtartja azokat, és csak ezt az értesítést rejti el.",
    "cloneDiscardPartialAlertTitle": "A(z) {{name}} elvetése hiányos maradt",
    "cloneDiscardPartialAlert": "Az elvetés már lefutott, és csak részben sikerült. Sikertelen: {{steps}}. Minden más eltávolításra került.",
    "cloneDiscardPartialRetry": "A bérlő és az adatbázisa még megvan — az elvetés újra futtatható.",
    "cloneDiscardPartialManual": "A bérlő és az adatbázisa már nincs meg; a fenti maradványokat kézzel kell eltávolítani. A „Figyelmen kívül hagyás” csak ezt az értesítést rejti el.",
    "cloneCleanupStepRevokeMemberships": "tagságok visszavonása",
    "cloneCleanupStepDeactivateZitadelOrg": "a Zitadel-szervezet deaktiválása",
    "cloneCleanupStepDropDatabase": "az adatbázis törlése",
    "cloneCleanupStepDeleteTenantRow": "a bérlő rekordjának törlése",
    "cloneDiscard": "Elvetés és törlés",
    "cloneDismiss": "Figyelmen kívül hagyás",
    "cloneDiscardTitle": "Hiányos másolat elvetése",
    "cloneDiscardDescription": "A(z) {{name}} bérlő, az adatbázisa és a közben létrehozott összes tagság véglegesen törlődik. A művelet nem vonható vissza.",
    "cloneDiscardSuccess": "A hiányos másolat elvetve",
    "cloneDiscardPartial": "A másolatot csak részben sikerült eltávolítani. Az értesítés addig marad látható, amíg a maradványokat el nem távolítják.",
    "cloneDismissSuccess": "Értesítés elrejtve",
    "cloneFailed": "Nem sikerült a bérlő duplikálása",
    "editDescription": "Bérlő adatainak frissítése",
    "searchPlaceholder": "Bérlők keresése...",
    "tenantName": "Bérlő neve",
    "tenantNamePlaceholder": "Adja meg a bérlő nevét",
    "tenantNameRequired": "A bérlő neve kötelező",
    "tenantSlug": "Bérlő azonosító",
    "tenantSlugPlaceholder": "berlo-azonosito",
    "tenantSlugRequired": "A bérlő azonosító kötelező",
    "tenantSlugPattern": "Az azonosító csak kisbetűket, számokat és kötőjeleket tartalmazhat",
    "tenantSlugHelper": "URL-barát azonosító (automatikusan generálódik a névből)",
    "tenantType": "Bérlő típusa",
    "tenantTypePlaceholder": "Válasszon bérlő típust",
    "tenantTypeCustomer": "Ügyfél",
    "tenantTypePartner": "Partner",
    "expirationDate": "Lejárati dátum",
    "expirationHelper": "Hagyja üresen, ha nincs lejárat",
    "cancel": "Mégse",
    "createFailed": "Nem sikerült a bérlő létrehozása",
    "updateFailed": "Nem sikerült a bérlő frissítése",
    "columnName": "Név",
    "columnSlug": "Azonosító",
    "columnType": "Típus",
    "columnAccount": "Fiók",
    "accountLabel": "Fiók: {{name}}",
    "noAccount": "Nincs fiók",
    "columnStatus": "Státusz",
    "columnExpires": "Lejárat",
    "columnMembers": "Tagok",
    "columnProcesses": "Folyamatok",
    "filterAll": "Összes",
    "statusActive": "Aktív",
    "statusInactive": "Inaktív",
    "expiresNever": "Soha",
    "hideExpired": "Lejártak elrejtése",
    "deleteSuccess": "Bérlő sikeresen törölve",
    "deleteFailed": "Nem sikerült a bérlő törlése",
    "deleteTitle": "Bérlő törlése",
    "deleteDescription": "Biztosan törölni szeretné ezt a bérlőt? Ez az összes kapcsolódó adatot is törli. Ez a művelet nem vonható vissza.",
    "deleteConfirmInstruction": "Írja be a <strong /> nevet a törlés megerősítéséhez.",
    "deleteConfirmPlaceholder": "Írja be a bérlő nevét a megerősítéshez",
    "cloneWarningDemoTitle": "Demó: új bejelentkezési adatok jönnek létre",
    "cloneWarningDemo": "A másolat minden felhasználót átmásol, de minden e-mail-cím új demócímre íródik át (pl. demo+jane.doe.12@bliks.io), és minden felhasználó az alább megadott demójelszót kapja. A korábbi demók felhasználói így nem férnek hozzá ehhez a demóhoz.",
    "tenantTypeDemo": "Demó",
    "tenantDescription": "Megjegyzés",
    "tenantDescriptionPlaceholder": "pl. Demó az XYZ cég részére",
    "columnDescription": "Megjegyzés",
    "demoPassword": "Demójelszó",
    "demoPasswordRequired": "Demójelszó szükséges: legalább 8 karakter, nagybetűvel, kisbetűvel és számjeggyel",
    "demoPasswordHint": "Közös jelszó a demó összes felhasználójához. Legalább 8 karakter, nagybetűvel, kisbetűvel és számjeggyel.",
    "homeOrgLabel": "Otthoni szervezet",
    "homeOrgNotSet": "Nincs beállítva",
    "homeOrgMoveWarningTitle": "A bejelentkezési fiók újra létrejön",
    "homeOrgMoveWarning": "A felhasználó másik otthoni szervezetbe helyezése újra létrehozza a bejelentkezési fiókját. A jelszó, a passkey-k és az MFA elvesznek, az aktív munkamenetek az új meghívás befejezéséig nem tudnak megerősített hitelesítést végezni, és új meghívó e-mail kerül kiküldésre.",
    "homeOrgNoTargets": "Ez a személy egyetlen olyan SSO-szervezetnek sem tagja, amely otthoni szervezetként beállítható.",
    "homeOrgDeletedBadge": "Otthoni szervezet törölve",
    "homeOrgDeletedTooltip": "A felhasználó otthoni szervezete törölve lett — a bejelentkezés blokkolva van (vagy hamarosan blokkolva lesz). Rendeljen hozzá új otthoni szervezetet a hozzáférés helyreállításához.",
    "homeOrgDeletedAlertTitle": "Otthoni szervezet törölve — a fiók zárolva",
    "homeOrgDeletedAlert": "A felhasználó otthoni szervezete törölve lett, ezért a bejelentkezése blokkolva van (vagy hamarosan blokkolva lesz). Válasszon lent új otthoni szervezetet a hozzáférés helyreállításához.",
    "homeOrgDeletedNoTargetsAlert": "A felhasználó otthoni szervezete törölve lett, ezért a bejelentkezése blokkolva van (vagy hamarosan blokkolva lesz). Nincs kiválasztható célszervezet — először adjon a felhasználónak tagságot egy SSO-szervezetben, majd rendelje hozzá azt új otthoni szervezetként.",
    "hubspotCompanyId": "HubSpot cég-azonosító",
    "hubspotCompanyIdPlaceholder": "pl. 340997605594",
    "hubspotPartnerCompanyIdHelper": "A partnercég HubSpot cégazonosítója („Partner” típus).",
    "cloneSource": "Sablon",
    "cloneSourceHint": "Minden adat erről a munkaterületről másolódik.",
    "cloneSourcePlaceholder": "Válasszon munkaterületet",
    "cloneSourceRequired": "Válasszon munkaterületet, amelyről másolunk",
    "createDemo": "Demó létrehozása",
    "createDemoDescription": "A demó egy meglévő munkaterület másolataként jön létre — átveszi annak tartalmát, de saját belépési adatokat kap.",
    "hubspotCompanyIdHelper": "Az ügyfél HubSpot cég-azonosítója. Összekapcsolja a HubSpot céget ezzel a Bliks tenanttal."
  },
  "recordingAnalytics": {
    "title": "Felvételi elemzések",
    "description": "Átlagos aktív felvételi idő folyamatonként, bérlőkön át",
    "scope": "Bérlő",
    "allTenants": "Összes bérlő",
    "empty": "Még nincs felvételi idő adat",
    "tenant": "Bérlő",
    "process": "Folyamat",
    "minutesSuffix": "{{value}} perc",
    "avgPerStep": "Átl. idő lépésenként",
    "avgPerProcess": "Átl. idő folyamatonként",
    "acrossSteps": "{{count}} lépésfelvétel alapján",
    "acrossProcesses": "{{count}} folyamat alapján",
    "processCount": "Folyamatok",
    "stepCount": "Lépések",
    "total": "Összes idő",
    "step": "Lépés",
    "stepTime": "Felvételi idő"
  },
  "aiUsage": {
    "title": "MI-használat",
    "description": "MI-költségek és tokenfelhasználás bérlőnként",
    "tenantTabDescription": "A bérlő teljes MI-költsége és tokenfelhasználása forrás és modell szerint",
    "scope": "Bérlő",
    "allTenants": "Összes bérlő",
    "range": "Időszak",
    "range7d": "Elmúlt 7 nap",
    "range30d": "Elmúlt 30 nap",
    "range90d": "Elmúlt 90 nap",
    "rangeAll": "Teljes időszak",
    "empty": "Még nincs rögzített MI-használat",
    "loadError": "Az MI-használati adatok betöltése nem sikerült",
    "tenant": "Bérlő",
    "totalCost": "Összköltség",
    "cost": "Költség",
    "calls": "Hívások",
    "callsBreakdown": "{{generation}} generálás · {{embedding}} beágyazás · {{transcription}} átirat",
    "acrossCalls_one": "{{count}} hívás alapján",
    "acrossCalls_other": "{{count}} hívás alapján",
    "tokens": "Tokenek",
    "tokensBreakdown": "{{input}} bemenet · {{output}} kimenet",
    "transcription": "Átirat",
    "minutesSuffix": "{{value}} perc",
    "source": "Forrás",
    "unknownSource": "Ismeretlen forrás",
    "kind": "Típus",
    "kindFeature": "Funkció",
    "kindApp": "Alkalmazás",
    "model": "Modell",
    "inputTokens": "Bemeneti tokenek",
    "outputTokens": "Kimeneti tokenek",
    "priceMissingEvents_one": "{{count}} hívásnak nincs árbejegyzése, 0 költséggel számolva",
    "priceMissingEvents_other": "{{count}} hívásnak nincs árbejegyzése, 0 költséggel számolva",
    "priceMissingWarning_one": "{{count}} hívásnak nincs árbejegyzése — a költségösszegek alulbecsültek",
    "priceMissingWarning_other": "{{count}} hívásnak nincs árbejegyzése — a költségösszegek alulbecsültek",
    "failedTenantsWarning_one": "{{count}} bérlő nem volt olvasható — az összegek hiányosak",
    "failedTenantsWarning_other": "{{count}} bérlő nem volt olvasható — az összegek hiányosak"
  },
  "partnerContent": {
    "title": "Partnertartalmak",
    "description": "Amit minden értékesítési partner lát: anyagok és videók az Info Hubban, valamint a hírek a kezdőlapjukon.",
    "tabs": {
      "materials": "Info Hub",
      "news": "Hírek"
    },
    "status": {
      "published": "Közzétéve",
      "draft": "Piszkozat"
    },
    "filter": {
      "all": "Összes"
    },
    "emptyFiltered": "Egy elem sem felel meg a szűrőnek.",
    "columns": {
      "order": "Sorrend",
      "title": "Cím",
      "status": "Állapot",
      "languages": "Nyelvek",
      "updatedAt": "Módosítva",
      "publishedAt": "Közzétéve"
    },
    "actions": {
      "publish": "Közzététel",
      "unpublish": "Visszavonás",
      "saveDraft": "Mentés piszkozatként",
      "undo": "Visszavonás",
      "moveUp": "Feljebb",
      "moveDown": "Lejjebb"
    },
    "toast": {
      "published": "Közzétéve. A partnerek most már látják.",
      "saved": "Piszkozatként mentve.",
      "saveFailed": "A mentés nem sikerült. Kérjük, próbálja újra."
    },
    "completeness": {
      "complete": "kész",
      "partial": "hiányos",
      "empty": "hiányzik"
    },
    "languages": {
      "title": "Nyelvek",
      "contentTitle": "Tartalom nyelvenként",
      "hint": "A német kötelező. Ha egy nyelv hiányzik, a partnerek az angol, annak hiányában a német változatot látják.",
      "present": "{{language}}: megvan",
      "missing": "{{language}}: hiányzik"
    },
    "fields": {
      "titleIn": "Cím ({{language}})",
      "descriptionIn": "Leírás ({{language}})"
    },
    "materials": {
      "add": "Anyag hozzáadása",
      "createTitle": "Új anyag",
      "editTitle": "Anyag szerkesztése",
      "dialogDescription": "Közzététel után minden partner Info Hubjában megjelenik.",
      "general": "Általános",
      "kind": "Típus",
      "kinds": {
        "file": "Fájl",
        "video": "Videó"
      },
      "kindHints": {
        "file": "PDF, PowerPoint, Word vagy Excel, nyelvenként egy fájl",
        "video": "Egy YouTube-videó"
      },
      "videoUrl": "YouTube-link",
      "videoPreview": "A videó előnézeti képe",
      "needsFile": "A közzétételhez az anyagnak legalább egy fájl kell.",
      "empty": "Még nincsenek anyagok. Adja hozzá az elsőt.",
      "loadError": "Az anyagokat nem sikerült betölteni.",
      "deleteEntityPhrase": "ezt az anyagot a fájljaival együtt",
      "files": {
        "label": "Fájl",
        "dropTitle": "Húzza ide a(z) {{language}} fájlt",
        "dropHint": "PDF, PowerPoint, Word vagy Excel, legfeljebb 25 MB",
        "choose": "A(z) {{language}} fájl kiválasztása",
        "replace": "Csere",
        "remove": "A(z) {{language}} fájl eltávolítása",
        "uploadOnSave": "mentéskor feltöltődik",
        "removedOnSave": "{{name}} mentéskor törlődik.",
        "rejected": {
          "format": "Engedélyezett: PDF, PowerPoint, Word és Excel.",
          "size": "A fájl nagyobb 25 MB-nál."
        }
      }
    },
    "news": {
      "add": "Hír írása",
      "createTitle": "Új hír",
      "editTitle": "Hír szerkesztése",
      "dialogDescription": "Közzététel után megjelenik a partnerek kezdőlapján; a célcsoport dönti el, kiknél.",
      "general": "Általános",
      "pinned": "Első helyen mutatni",
      "pin": "Első helyen mutatni",
      "unpin": "Ne első helyen mutassa",
      "bodyIn": "Szöveg ({{language}})",
      "preview": "Előnézet",
      "previewHint": "Így látják a partnerek a hírt ezen a nyelven: {{language}}.",
      "empty": "Még nincsenek hírek. Írja meg az elsőt.",
      "loadError": "A híreket nem sikerült betölteni.",
      "deleteEntityPhrase": "ezt a hírt",
      "eyebrow": "Felcím",
      "eyebrowIn": "Felcím ({{language}})",
      "footnoteIn": "Lábjegyzet ({{language}})",
      "links": "Gombok",
      "primaryAction": "Fő gomb",
      "secondaryAction": "Második gomb",
      "actionLabelIn": "{{action}} felirata ({{language}})",
      "images": {
        "title": "Képek",
        "logo": "Logó",
        "logoHint": "Felül jelenik meg, pl. OMR és G2 egy képen. PNG, JPG, WebP vagy SVG, legfeljebb 2 MB.",
        "image": "Kép",
        "imageHint": "Négyzetesen a szöveg mellett jelenik meg. PNG, JPG, WebP vagy SVG, legfeljebb 2 MB.",
        "choose": "{{label}} kiválasztása",
        "remove": "{{label}} eltávolítása",
        "rejected": {
          "format": "Engedélyezett: PNG, JPG, WebP és SVG.",
          "size": "A kép nagyobb 2 MB-nál."
        }
      },
      "audience": "Célcsoport",
      "audienceHint": "Minden partner, vagy csak az értékesítési appot használó partnerek.",
      "audienceAll": "Minden partner",
      "audienceSales": "Az értékesítési app felhasználói"
    }
  },
  "accountAdmin": {
    "addAccount": "Fiók létrehozása",
    "addAccountHint": "Keresse meg a céget, amely ügyfél lesz — a hozzárendelés a HubSpot-azonosítóval történik.",
    "addTenant": "Munkaterület létrehozása",
    "assignCompany": "Cég hozzárendelése",
    "assignCompanyHint": "Keresés név vagy domain alapján — a hozzárendelés mindig a HubSpot-azonosítóval történik, sosem névvel.",
    "backToAccounts": "Vissza a fiókokhoz",
    "changeCompany": "Cég módosítása",
    "childCount": "{{count}} alárendelt",
    "children": "Alárendelt fiókok",
    "columnGroup": "Csoport",
    "columnName": "Ügyfél",
    "columnTenants": "Munkaterületek",
    "companiesUnavailable": "A cégnevek nem tölthetők be a HubSpotból — a fiókok teljesek, csak a nevek hiányoznak.",
    "company": {
      "ambiguous": {
        "primary": "Több kapcsolattartó viseli a fő kapcsolattartó címkét. Az első számít — kérjük, tegye egyértelművé a CRM-ben.",
        "billing": "Több kapcsolattartó viseli a számlázási címkét. Az első számít — kérjük, tegye egyértelművé a CRM-ben."
      },
      "billingContactRole": "Számla",
      "contactUnnamed": "Névtelen kapcsolattartó",
      "heading": "Cég a CRM-ben",
      "noAddress": "Nincs cím a CRM-ben",
      "noBillingContact": "A CRM-ben nincs számlázási kapcsolattartó megjelölve",
      "noBillingEmail": "Nincs számlacímzett megadva",
      "noContact": "A CRM-ben nincs fő kapcsolattartó megjelölve",
      "noVatId": "Nincs adószám megadva",
      "primaryContactRole": "Ajánlat",
      "refresh": "Frissítés a HubSpotból",
      "refreshChanged": "Törzsadatok átvéve a HubSpotból.",
      "refreshUnchanged": "HubSpot beolvasva — nincs újdonság.",
      "refreshUnread": "A HubSpot nem volt olvasható. A legutóbb beolvasott állapot marad érvényben.",
      "unknownName": "Ismeretlen név",
      "unlinked": "Még nincs cég összekapcsolva",
      "vatConfirmed": "megerősítve",
      "vatRejected": "nem megerősített",
      "vatUnchecked": "ellenőrizetlen"
    },
    "companyTaken": "Már hozzárendelve",
    "createCompany": "„{{name}}” létrehozása a HubSpotban",
    "createWithoutCompany": "Létrehozás cég nélkül",
    "description": "Az ügyfelek — jogi személyenként egy fiók, amely több munkaterületet is működtethet.",
    "detachParent": "Leválasztás",
    "empty": "Még nincsenek fiókok.",
    "group": "Csoport",
    "groupHint": "A fiókok egy ernyő alá rendezhetők — cégcsoport, lánc, hálózat. A kapcsolat önmagában semmit nem biztosít: nincs tagok közti olvasás, közös licenc vagy örökölt fizetési mód.",
    "noChildren": "Ehhez a fiókhoz nem tartozik másik.",
    "noCompany": "Nincs rögzített HubSpot cég",
    "noParent": "Nem tartozik csoporthoz",
    "notFound": "A fiók nem található.",
    "openIn": "Megnyitás itt: {{system}}",
    "parent": "Szülő fiók",
    "partOf": "Ide tartozik:",
    "saved": "Mentve.",
    "searchCompanyEmpty": "Nem található cég.",
    "searchCompanyMin": "Írjon be legalább három karaktert.",
    "searchCompanyPlaceholder": "Név vagy domain …",
    "searching": "Keresés …",
    "tenants": "Munkaterületek",
    "title": "Fiókok",
    "unnamed": "Névtelen"
  }
}
